import Button from '@rategravity/frontend/components/button';
import fecha from 'fecha';
import React from 'react';
import Dashboard from '../../components/dashboard';
import YouCanBookMeButton from '../../components/you-can-book-me';

const MINIMUM_CLOSE_TIMESPAN_NS = 25 * 24 * 60 * 60 * 1000; // 25 days from today

const style = {
  row: { paddingBottom: '10px', paddingTop: '10px' },
  prompt: { fontSize: '1.3em' },
  strikeThrough: { marginBottom: '20px', marginTop: '20px' }
};

export default ({ firstName, advisor, actionPipe, prefill, comparisonQuery = {}, children }) => {
  const escape = encodeURIComponent;
  const query = Object.keys(comparisonQuery)
    .map((k) => `${escape(k)}=${escape(comparisonQuery[k])}`)
    .join('&');

  // We cannot service folks who are closing in less than
  const minimumCloseDate = fecha.format(Date.now() + MINIMUM_CLOSE_TIMESPAN_NS, 'MM/DD/YYYY');
  return (
    <Dashboard>
      {children}
      <div style={{ margin: '2em', marginTop: '2.75em', maxWidth: 720 }}>
        <div style={style.row}>
          <h1>
            Hey {firstName}, we noticed your close date is less than 25 days away. If you switched
            lenders at this point your new lender would not have enough time to process your loan.
          </h1>
        </div>
        <div style={{ ...style.prompt, ...style.row }}>
          We&apos;d still love to help! Upload your existing lender offers and we can make sure
          you&apos;re getting a fair deal.
        </div>
        <div style={style.row}>
          <a href={`https://hello.ownup.com/comparison?${query}`}>
            <Button>UPLOAD YOUR EXISTING OFFERS</Button>
          </a>
        </div>
        <hr style={style.strikeThrough} />
        <div>
          <div style={{ ...style.prompt, ...style.row }}>
            <strong>Able to move your closing date to {minimumCloseDate} or later?</strong> Set up a
            review call to see how much we can save you by shopping a network of vetted lenders.
          </div>
          <div style={style.row}>
            <YouCanBookMeButton
              advisor={advisor}
              purpose={'acceptedoffer'}
              prefill={prefill}
              actionPipe={actionPipe}
              secondary
            >
              SETUP 7 MINUTE REVIEW CALL
            </YouCanBookMeButton>
          </div>
        </div>
      </div>
    </Dashboard>
  );
};



// WEBPACK FOOTER //
// ./src/products/shared/comparison-dashboard.js